const DeliveryReport=()=>{
    return(
        <div>Delivery </div>
    )
}
export default DeliveryReport;